(function () {
  'use strict';

  /* ── Mobile drawer (declared first so closeDrawer is available to scroll handler) ── */
  var drawer   = document.getElementById('ir-hd-drawer');
  var overlay  = document.getElementById('ir-hd-overlay');
  var burger   = document.getElementById('ir-hd-burger');
  var closeBtn = document.getElementById('ir-hd-drawer-close');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    burger.classList.add('is-open');
    burger.setAttribute('aria-expanded', 'true');
    document.body.classList.add('ir-hd-locked');
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    burger.classList.remove('is-open');
    burger.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('ir-hd-locked');
  }

  if (burger)   burger.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay)  overlay.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  /* ── Scroll: shadow + hide-on-down / show-on-up ── */
  var header      = document.getElementById('ir-header');
  var hdWrap      = document.getElementById('ir-hd-wrap');
  var lastScrollY = window.scrollY;

  function syncBodyPad() {
    if (hdWrap) {
      document.body.style.paddingTop = hdWrap.offsetHeight + 'px';
    }
  }
  syncBodyPad();
  window.addEventListener('resize', syncBodyPad, { passive: true });

  window.addEventListener('scroll', function () {
    var currentY = window.scrollY;

    if (header) {
      header.classList.toggle('is-scrolled', currentY > 10);
    }

    if (hdWrap) {
      if (currentY > lastScrollY && currentY > 80) {
        /* scrolling down — hide header */
        hdWrap.classList.add('is-hidden');
        closeDrawer();
      } else if (currentY < lastScrollY) {
        /* any upward scroll — immediately show header */
        hdWrap.classList.remove('is-hidden');
      }
    }

    lastScrollY = currentY;
  }, { passive: true });

  /* ── Cart count ── */
  function updateCartCount(count) {
    document.querySelectorAll('[data-ir-cart-count]').forEach(function (el) {
      el.textContent = count > 0 ? count : '';
      el.setAttribute('data-count', count);
    });
  }

  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) { updateCartCount(cart.item_count); })
    .catch(function () {});

  document.addEventListener('cart:updated', function (e) {
    if (e.detail && typeof e.detail.itemCount !== 'undefined') {
      updateCartCount(e.detail.itemCount);
    }
  });

  /* ── Cart icon → open cart drawer ── */
  document.querySelectorAll('.ir-hd-icon-btn[aria-label="Cart"], .ir-hd-icon-btn[aria-label^="Cart ("]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.open === 'function') {
        e.preventDefault();
        cartDrawer.open(btn);
      }
    });
  });

  /* ── Drawer accordion (Learn submenu) ── */
  document.querySelectorAll('.ir-hd-drawer-toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.ir-hd-drawer-item');
      var wasOpen = item.classList.contains('is-open');
      document.querySelectorAll('.ir-hd-drawer-item.is-open').forEach(function (el) {
        el.classList.remove('is-open');
      });
      if (!wasOpen) item.classList.add('is-open');
    });
  });

})();
